import { render } from "./editStudentsInfo.vue?vue&type=template&id=2b1a95e6&scoped=true"
import script from "./editStudentsInfo.vue?vue&type=script&lang=js"
export * from "./editStudentsInfo.vue?vue&type=script&lang=js"

import "./editStudentsInfo.vue?vue&type=style&index=0&id=2b1a95e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1a95e6"]])

export default __exports__